export default {
  error: 'Ошибка',
  warning: 'Предупреждение',
  'error.errorNum': 'Ошибка: {number}',
  'error.notFound': '{entity} не найден',
  'error.page403': 'Извините, у вас нет доступа к этой странице',
  'error.page404': 'Извините, запрашиваемая страница не существует',
  'error.page500': 'Извините, что-то пошло не так',
  'error.pageWarning': 'Возникли проблемы при выполнении операции',
  'error.noPermissions': 'Недостаточно прав',
  'error.userExist': 'Пользователь уже существует',
  'error.userAssigned': 'Пользователь уже назначен на бизнес',
  'error.noEmail': 'Требуется email',
  'error.validEmail': 'Введите корректный email',
  'error.noConnection': 'Нет подключения к интернету',
  'error.na': 'Нет',
  'error.fileSize': 'Размер файла превышает лимит {size}МБ',
  'error.uploadRestriction': 'Разрешено загружать только файлы {extensions}',
  'error.reCAPTCHA.loaded': 'reCAPTCHA не загружена',
  'error.load.script': 'Не удалось загрузить скрипт',
};
